import { Typography, Button, Grid } from "@mui/material";
import { useTourContext } from "../../../../context/TourContext";
import { tutorialSectionType } from "../../../../context/TourContext";
import { dashboardSteps } from "../../PortalTour/DashboardSteps";
import { reportsSteps } from "../../PortalTour/ReportsSteps";
import { studentInsightsSteps } from "../../PortalTour/StudentInsightsSteps";
import usePersonAuthStore from "../../../store/personAuthStore"
import { useSlideInContext } from "ui";
import { mainMenuSteps } from "../../PortalTour/MainMenuSteps";
import usePersonStore from "../../../store/personStore";
import { canViewAllReports } from "ft-shared-graphql";
export default function SelectTourStep() {
    const { setTutorialSection } = useTourContext()
    const totalUnreadWorkLists = usePersonStore(state => state.totalUnreadWorkLists)
    const { toggleDrawer } = useSlideInContext()
    const tourSections = {
        ...dashboardSteps,
        ...mainMenuSteps,
        ...reportsSteps,
        ...studentInsightsSteps
    }
    const { roles } = usePersonAuthStore()
    const tutorialSections = Object.entries(tourSections)
        .filter(([section]) =>
            section !== "welcome" &&
            !section.startsWith("nextSection") && (
                !section.startsWith("report") || canViewAllReports(roles)
            )
            // && (section !== "actionsNeeded" || (totalUnreadWorkLists ?? 0) > 0)
        )
        .filter(([, section]) =>
            section.steps.some(
                step => !step.data?.access || step.data.access(roles)
            )
        );
    return (
        <Grid container spacing={1}>
            <Grid size={12}>
                <Typography>Which tutorial would you like to view?</Typography>
            </Grid>
            <Grid size={12}>
                {tutorialSections.map(([section, data]) => (
                    <Button sx={{ margin: 1 }}
                        key={section}
                        variant="contained"
                        onClick={() => {
                            toggleDrawer()
                            setTutorialSection(section as tutorialSectionType)
                        }}
                    >
                        {data.label}
                    </Button>
                ))}            </Grid>
        </Grid>
    )
}